/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestPaymentDto } from '../../models/contents-request-payment-dto';

export interface ContentsRequestPaymentControllerPay$Params {
  paymentId: string;
  clientWorkspaceId: string;
}

export function contentsRequestPaymentControllerPay(http: HttpClient, rootUrl: string, params: ContentsRequestPaymentControllerPay$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestPaymentControllerPay.PATH, 'patch');
  if (params) {
    rb.path('paymentId', params.paymentId, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestPaymentDto>;
    })
  );
}

contentsRequestPaymentControllerPay.PATH = '/api/contents-request-payment/{clientWorkspaceId}/pay/{paymentId}';
